"use client";

import React, { useEffect, useState } from "react";
import { Calendar, Clock, MapPin } from "lucide-react";
import { EVENT } from "./data";

const pad = (n: number) => String(Math.max(0, n)).padStart(2, "0");

const split = (ms: number) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
};

/** Live countdown to the race start, rendered only on the client to avoid hydration drift. */
const Countdown: React.FC = () => {
  const [now, setNow] = useState<number | null>(null);
  const target = new Date(EVENT.startsAt).getTime();

  useEffect(() => {
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = now === null ? null : target - now;
  const t = remaining === null ? null : split(remaining);
  const started = remaining !== null && remaining <= 0;

  const cells = [
    { value: t ? String(t.days).padStart(3, "0") : "---", label: "Días" },
    { value: t ? pad(t.hours) : "--", label: "Horas" },
    { value: t ? pad(t.minutes) : "--", label: "Minutos" },
    { value: t ? pad(t.seconds) : "--", label: "Segundos" },
  ];

  return (
    <div className="w-full text-center text-white select-none">
      <p className="mes-label opacity-80">
        {started ? "La carrera está en marcha" : "Tu meta te espera en"}
      </p>

      <div className="mt-4 md:mt-6 grid grid-cols-2 gap-x-6 gap-y-8 sm:flex sm:items-start sm:justify-center sm:gap-5 md:gap-8">
        {cells.map((c, i) => (
          <React.Fragment key={c.label}>
            <div className="flex flex-col items-center">
              <span
                className="mes-display tabular-nums text-[19vw] sm:text-[8.5vw] leading-none"
                suppressHydrationWarning
              >
                {c.value}
              </span>
              <span className="mes-label mt-3 opacity-80">{c.label}</span>
            </div>
            {i < cells.length - 1 && (
              <span className="hidden sm:inline mes-display text-[6vw] leading-none opacity-50 pt-[1vw]">
                :
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="mes-label mt-6 md:mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <span className="inline-flex items-center gap-1.5">
          <Calendar className="w-3.5 h-3.5 opacity-70" strokeWidth={2.25} />
          {EVENT.dateLong}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5 opacity-70" strokeWidth={2.25} />
          {EVENT.startTime}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5 opacity-70" strokeWidth={2.25} />
          {EVENT.place}
        </span>
      </div>
    </div>
  );
};

export default Countdown;
